import React, {useState} from 'react';
import './App.css';
import Alert from './components/Alert';
import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

function App() {

  const [mode, setMode] = useState("light"); // wheather dark mode is enabled or not
  const [alert, setAlert] = useState(null);


  const showAlert = (msg, type) => {
    setAlert({
      message : msg,
      type : type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 3000);

  }


  const toggleMode = () => {
    if(mode === 'light'){
      setMode("dark");
      document.body.style.backgroundColor = "#042743";
      showAlert("Dark mode is Enabled", "success");
    }
    else{
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("Dark mode is Disabled", "success");
    }
  }



  return (
    <>
  
      {/* <Navbar title = "TextUtils" mode = {mode} toggleMode = {toggleMode} />
      <Alert info = {alert} />
      <div className="container my-3">
          <TextForm heading ="Enter the text to analyze"  mode = {mode}  showAlert = {showAlert} />
          <About />
      </div> */}
    
      <Router>
        <Navbar title = "TextUtils" mode = {mode} toggleMode = {toggleMode} />
        <Alert info = {alert} />
        <div className="container my-3">
          <Routes>
              <Route exact path="/" element={<TextForm heading ="Enter the text to analyze"  mode = {mode}  showAlert = {showAlert} />} />
              <Route exact path="about" element={<About mode = {mode} />} />
          </Routes>
        </div>
      </Router>
    </>
  );
}


export default App;
